<template>
  <div class="jpgPreview">
    <heading type="h1">JPG Preview</heading>
  </div>
</template>

<script>
import Heading from '@/components/Heading/heading'

export default {
  name: 'jpgPreview',
  components: {
    Heading
  }
}
</script>

<style lang="scss">
    .jpgPreview {
        padding-top: 40px;
        text-align: center;
        width:100%;
        height:100%;
        background-color: red;
        color:white;
        position: absolute;
        top:0;
        left:0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dev/jpg-preview.vue